import type { TrackingEventProperties, TrackingEventPropertiesOverrides } from '@change-corgi/core/eventTracker';

/**
 * Every property key set by page-level tracking providers that are ancestors of the payment login flow
 * (`LoginModal` and `useLoginWithModal`), mapped to `undefined` so the page values are cleared from the
 * merged event. Use it as `TrackingContext` `properties`, or spread it first into an event payload so the
 * event's own keys still win.
 */
export const loginModalTrackingPropertyReset = {
	amount: undefined,
	bonus_cpm: undefined,
	bonus_impressions: undefined,
	category_tags: undefined,
	content: undefined,
	context: undefined,
	cpm: undefined,
	currency: undefined,
	custom_amount: undefined,
	exchange_rate: undefined,
	geo_reach: undefined,
	image: undefined,
	impression_count: undefined,
	impressions_to_fulfill: undefined,
	is_public: undefined,
	local_amount: undefined,
	own_petition: undefined,
	pathname: undefined,
	payment_term: undefined,
	payment_type: undefined,
	petition_id: undefined,
	price: undefined,
	product_flow: undefined,
	promote_transaction: undefined,
	promoted_bandit_variant_shown: undefined,
	public: undefined,
	quantity: undefined,
	relevant_location_localized_name: undefined,
	revenue_type: undefined,
	route_id: undefined,
	save_payment_method: undefined,
	signature_count: undefined,
	source_location: undefined,
	subscriber: undefined,
	subscription_program_country_slug: undefined,
	subscription_program_id: undefined,
	subscription_program_name: undefined,
	subscription_program_type: undefined,
	transaction_upsell_opt_in: undefined,
	use_saved_payment_method: undefined,
	visible_payment_types: undefined,
} as const satisfies TrackingEventProperties;

export const loginModalTrackingDefaultOverridesReset = {
	current_source: undefined,
} as const satisfies TrackingEventPropertiesOverrides;
